import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/md-cro")({
  head: () => buildRouteHead("/md-cro", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/services/full-service-medical-device-cro", replace: true });
  },
});
